import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { HgLocalStorageKey } from '@/models/HgLocalStorageKey';

import { StorageNamespace } from '../storage-namespaces';

function resetOpenedCount(
  tenantPlusStorageHelper: StorageHelper,
  storageKey: HgLocalStorageKey.PDP_OPENED_COUNT | HgLocalStorageKey.SRP_OPENED_COUNT,
): void {
  const currentDate = new Date().toISOString().substring(0, 10);
  const openedDate =
    tenantPlusStorageHelper.getLocalStorageItem(HgLocalStorageKey.BOTTOM_SHEET_OPENED_DATE) ?? '';

  if (currentDate !== openedDate) {
    tenantPlusStorageHelper.setLocalStorageItem(
      HgLocalStorageKey.BOTTOM_SHEET_OPENED_DATE,
      currentDate,
    );
    const openedCount = Number(tenantPlusStorageHelper.getLocalStorageItem(storageKey) ?? 0);

    if (openedCount < 0) {
      tenantPlusStorageHelper.setLocalStorageItem(storageKey, 0);
    }
  }
}

export function shouldOpenTenantPlusEngagementModal(
  storageKey: HgLocalStorageKey.PDP_OPENED_COUNT | HgLocalStorageKey.SRP_OPENED_COUNT,
): boolean {
  const tenantPlusStorageHelper = new StorageHelper(StorageNamespace.tenantPlus);
  const acknowledgedPlusService =
    tenantPlusStorageHelper.getLocalStorageItem(HgLocalStorageKey.ACKNOWLEDGE_TENANTPLUS_SERVICE) ??
    false;

  if (acknowledgedPlusService) {
    return false;
  }

  if (storageKey === HgLocalStorageKey.PDP_OPENED_COUNT) {
    const detailPageStorageHelper = new StorageHelper(StorageNamespace.detailsPage);

    if (
      !detailPageStorageHelper.getLocalStorageItem(HgLocalStorageKey.CONTACT_FORM_CONTENT_SNAPSHOT)
    ) {
      return false;
    }
  }

  resetOpenedCount(tenantPlusStorageHelper, storageKey);

  const PDP_OPENING_THRESHOLD = 5;
  const SRP_OPENING_THRESHOLD = 15;
  const threshold =
    storageKey === HgLocalStorageKey.PDP_OPENED_COUNT
      ? PDP_OPENING_THRESHOLD
      : SRP_OPENING_THRESHOLD;
  const openedCount = Number(tenantPlusStorageHelper.getLocalStorageItem(storageKey) ?? 0);

  if (openedCount < 0) {
    return false;
  }

  const shouldOpenEngagementModal = openedCount >= threshold;

  if (shouldOpenEngagementModal) {
    tenantPlusStorageHelper.setLocalStorageItem(storageKey, -1);
  } else {
    tenantPlusStorageHelper.setLocalStorageItem(storageKey, openedCount + 1);
  }

  return shouldOpenEngagementModal;
}
